var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3 15.39L5.22 15.59L3 21L8.61 18.7M18.8204 4.13183L19.8669 5.17835C20.1531 5.47526 20.3135 5.87119 20.3149 6.28355C20.3162 6.69591 20.1582 7.09285 19.874 7.39159L8.56027 18.7053L5.27223 15.4172L16.5859 4.10354C16.8884 3.81579 17.2915 3.65769 17.7089 3.66297C18.1264 3.66825 18.5253 3.83651 18.8204 4.13183Z",
    stroke: "#1C1C1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8ec2a16128c5175cf04a6794ad510325.svg";
export { ForwardRef as ReactComponent };